import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RenderField, Validators } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
    onDelete: Function;
};
type Props = {
    onClose: Function;
    currentAddress: string;
    isPositionsCountIncorrect: boolean;
};
const AddAoiForm = (props: InjectedFormProps & ConnectedProps & Props) => {
    const { handleSubmit, submitting, t } = props;
    return (
        <div className="poipreview">
            <div className="poipreview__title">
                <h5>Opcje Strefy</h5>
            </div>
            <form className="form" onSubmit={handleSubmit}>
                {props.isPositionsCountIncorrect && <div className="form_field--error">{t('threePosRequired')}</div>}
                <Field name="title" component={RenderField} type="text" placeholder={t('aoiName')} label={t('aoiName')} validate={[Validators.required]} />
                <Field name="address" component={RenderField} type="text" placeholder={t('address')} label={t('address')} validate={[Validators.required]} />
                <div className="poiForm__buttons">
                    {props.initialValues['title'] && (
                        <div className="poiForm__button-delete" onClick={async () => props.onDelete()}>
                            <img width="30" src={'/images/icons/garbage.svg'} />
                            <span className="btn btn--clean">{t('delete')}</span>
                        </div>
                    )}
                    <div className="poiForm__button-delete" onClick={() => props.onClose()}>
                        <span className="btn btn--clean">{t('cancel')}</span>
                    </div>
                    {/* {!props.initialValues['title'] && ( */}
                    <button disabled={submitting || props.isPositionsCountIncorrect} className="btn btn--blue" type="submit">
                        {t('save')}
                    </button>
                    {/* )} */}
                </div>
            </form>
        </div>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}

export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'addAoiForm',
        enableReinitialize: true
    })
)(AddAoiForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/AddAoiForm.tsx